module.exports = __webpack_public_path__ + "static/media/woo14.1cf49155.png";